import { useEffect, useState } from "react";
import { motion } from "framer-motion";

export const ease = [0.22, 1, 0.36, 1];

// Tracks a CSS media query so components can swap in touch/phone-friendly behaviour.
export const useMedia = (query) => {
  const [on, setOn] = useState(() => typeof window !== "undefined" && window.matchMedia(query).matches);
  useEffect(() => {
    const m = window.matchMedia(query);
    const sync = () => setOn(m.matches);
    sync();
    m.addEventListener("change", sync);
    return () => m.removeEventListener("change", sync);
  }, [query]);
  return on;
};

export const useIsMobile = () => useMedia("(max-width: 767px)");
export const useCoarse = () => useMedia("(hover: none), (pointer: coarse)");

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 1, ease, delay }}
  >
    {children}
  </motion.div>
);

const parent = (delay) => ({
  hidden: {},
  show: { transition: { staggerChildren: 0.1, delayChildren: delay } },
});
const child = {
  hidden: { y: "115%", rotate: 3 },
  show: { y: "0%", rotate: 0, transition: { duration: 1.15, ease } },
};

export const MaskLines = ({ lines, className = "", delay = 0, play }) => {
  const trigger =
    play === undefined
      ? { whileInView: "show", viewport: { once: true, margin: "-60px" } }
      : { animate: play ? "show" : "hidden" };
  return (
    <motion.span className={`block ${className}`} variants={parent(delay)} initial="hidden" {...trigger}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span className="block origin-left" variants={child}>
            {line}
          </motion.span>
        </span>
      ))}
    </motion.span>
  );
};

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`font-mono text-[11px] uppercase tracking-[0.28em] text-slate-400 flex items-center gap-3 ${className}`}>
    <span className="h-px w-8 bg-cyan-300/60" />
    {children}
  </p>
);
